// setup-generate.ts — first-run "AI starter kit". Collect a tiny profile, ask the
// model to propose a realistic starter set (goals/projects/tasks/habits/notes)
// tailored to the user's work, then reuse normalizeBatchItems → addEntitiesBatch.

import type { AiGenerateRequest } from "./ai-client";
import { FILE_PLAN_SCHEMA } from "./file-extract";

export interface SetupProfile {
  /** Role / occupation, e.g. "Lập trình viên", "Sinh viên". */
  role: string;
  /** Main goal or what they want to improve (free text). */
  focus: string;
  /** Life areas they care about, e.g. ["Công việc","Sức khoẻ"]. */
  areas: string[];
  /** Optional extra note. */
  note?: string;
}

/** Suggested area chips for the setup form. */
export const SETUP_AREAS = ["Công việc", "Sức khoẻ", "Học tập", "Tài chính", "Cá nhân", "Sáng tạo"];

/** Build the AI request that generates a tailored starter kit (JSON {items:[...]}). */
export function buildSetupGenRequest(profile: SetupProfile, todayIso: string): AiGenerateRequest {
  const areas = profile.areas.length ? profile.areas.join(", ") : "(không nêu)";
  const prompt = `Hôm nay là ${todayIso}. Đây là người dùng MỚI của Personal Life OS (app quản lý cuộc sống: việc, dự án, mục tiêu, thói quen, ghi chú).

Hồ sơ người dùng:
- Vai trò/công việc: ${profile.role || "(không nêu)"}
- Mục tiêu / muốn cải thiện: ${profile.focus || "(không nêu)"}
- Lĩnh vực quan tâm: ${areas}
${profile.note ? `- Ghi chú thêm: ${profile.note}\n` : ""}
Hãy ĐỀ XUẤT một bộ khởi đầu THỰC TẾ và VỪA PHẢI, sát với vai trò + lĩnh vực trên:
- ~1–3 mục tiêu (goal) định hướng
- ~2–4 dự án (project), mỗi dự án vài việc (task), thêm việc con (subtasks) khi hợp lý
- 2–4 thói quen (habit) phù hợp (targetPerWeek)
- 1–2 ghi chú (note) tài nguyên/định hướng
Liên kết bằng projectName/goalName (đặt trùng đúng tên goal/project trong danh sách). Suy ngày tương đối ra YYYY-MM-DD theo hôm nay. Viết tiếng Việt, cụ thể, tránh chung chung. KHÔNG tạo quá nhiều mục.

Chỉ trả về JSON hợp lệ theo schema (một object có khoá "items").`;

  return {
    contents: [{ role: "user", parts: [{ text: prompt }] }],
    generationConfig: { maxOutputTokens: 4096, temperature: 0.5 },
    responseSchema: FILE_PLAN_SCHEMA,
  };
}
